/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RequiresToothDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function RequiresToothDetails({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/ActionsAction/Edit/Content/RequiresToothDetails",
  onChange
  
}) {
let editRequiresToothDetailsValueData = fromData.useDataValue({ viewPath,
context: 'edit',
path: 'requires_tooth_details',
})
let editRequiresToothDetailsChangeData = fromData.useDataChange({ viewPath,
context: 'edit',
path: 'requires_tooth_details',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="edit.requires_tooth_details"
 value={editRequiresToothDetailsValueData}
 onChange={editRequiresToothDetailsChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Requires tooth # / surface"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}